export const checkIsStripe = (paymentMethod) => {
  return paymentMethod?.paymentGateway?.provider === "Stripe" && paymentMethod?.paymentGateway?.keys?.publicKey;
};


export const checkIsStripeByPaymentGateway = (paymentGateway) => {
  return paymentGateway?.provider === "Stripe" && paymentGateway?.keys?.publicKey;
};

export const checkIsTranzila = (paymentMethod) => {
  return paymentMethod?.paymentGateway?.provider === "Tranzila";
};

export const checkIsTranzilaByPaymentGateway = (paymentGateway) => {
  return paymentGateway?.provider === "Tranzila";
};
